/* eslint-disable react-hooks/rules-of-hooks */
import { Typography } from "@material-ui/core";
import { useFieldValue } from "formik";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import { LiteBox } from "../components/lite/LiteBox";
import useStyles from "../containers/data/forms/forms-styles";
import { dark } from "../hooks/use-map-theme-styles";
import { ControlState } from "../models/flexible/control-state";
import { formatTreatment } from "../utils/base-agreement-formatters";
import { firstLetterUppercase } from "../utils/first-letter-uppercase";
import { GeneralFieldController } from "./general-field-controller";
import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";

interface IRenderPackValueProps {
	path: string;
}

const RenderPackValue = (props: IRenderPackValueProps) => {
	const [value] = useFieldValue(props.path);
	const classes = useStyles();
	const { t } = useTranslation();
	const formattedValue = value ? formatTreatment(value) : "--";

	return (
		<LiteBox className={classes.colMedium} pr={5} py={2.5} pl={1.5}>
			<Typography variant="caption" color="textSecondary">
				{firstLetterUppercase(t("packs"))}
			</Typography>
			<LiteBox>
				<Typography variant="body2" style={{ color: dark }} className={classes.readOnlyControlContent}>
					{formattedValue}
				</Typography>
			</LiteBox>
		</LiteBox>
	);
};

export class PackReferenceFieldController extends GeneralFieldController {
	override useControlState(_path: string): ControlState {
		const [decisionTherapy] = useFieldValue(AttributeIdentifiers.DecisionTherapy);

		return (decisionTherapy == null) ? "hidden" : "disabled";
	}

	customRenderContent(path: string): React.ReactElement {
		return <RenderPackValue path={path} />;
	}

	protected override createFieldValidationRuleByDataType(): Yup.AnySchema {
		return Yup.object().nullable().required();
	}
}
